import { ChatCallCardContent } from "../../types/chat/ChatContent";

const asNonEmptyString = (value: unknown): string | undefined =>
  typeof value === "string" && value.length > 0 ? value : undefined;

// A sibling module rather than an inline helper in parseChatResponse.ts, where BRIEF and
// RECORD_CARD live: those are one-line shape checks, and this one carries a rule worth testing on
// its own — the number is passed through untouched.
//
// phoneNumber is never trimmed or reformatted. The platform sends the stored value verbatim and
// guarantees only that it holds one digit, so "555-0128 ext. 4" must reach the card intact.
// companyName is omitted rather than set to undefined, so the object matches what the wire sent.
const parseCallCard = (payload: Record<string, unknown>): ChatCallCardContent | undefined => {
  const displayName = asNonEmptyString(payload.displayName);
  const phoneNumber = asNonEmptyString(payload.phoneNumber);
  if (!displayName || !phoneNumber) {
    return undefined;
  }
  const companyName = asNonEmptyString(payload.companyName);
  return { ...(companyName ? { companyName } : {}), displayName, phoneNumber };
};

export default parseCallCard;
